"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResponseReceivedError = void 0;
var HttpStatusCodes_1 = require("./HttpStatusCodes");
var ValidationError_1 = require("./ValidationError");
var NoResponseReceivedError = /** @class */ (function (_super) {
    __extends(NoResponseReceivedError, _super);
    function NoResponseReceivedError(customMessage) {
        var _this = _super.call(this, customMessage) || this;
        _this.customMessage = customMessage;
        _this.errorCode = HttpStatusCodes_1.httpStatusCodes.NO_RESPONSE_RECEIVED.statusCode;
        _this.errorType = HttpStatusCodes_1.httpStatusCodes.NO_RESPONSE_RECEIVED.errorType;
        _this.message = 'No response received.';
        Object.setPrototypeOf(_this, NoResponseReceivedError.prototype);
        return _this;
    }
    NoResponseReceivedError.prototype.serializeErrors = function () {
        return [
            {
                message: this.message || '',
                customMessage: this.customMessage || '',
                errorCode: this.errorCode,
                errorType: this.errorType,
            },
        ];
    };
    return NoResponseReceivedError;
}(ValidationError_1.ValidationError));
exports.NoResponseReceivedError = NoResponseReceivedError;
